import './Tag.css'

import type { ReactNode } from 'react'

import { cx } from '../utilities/cx'
import { Icon } from './Icon'

export type TagColor = 'gold' | 'violet' | 'magenta' | 'teal' | 'amber' | 'red'

const tagColorMap: Record<TagColor, string> = {
  gold: 'var(--color-gold-500-solid)',
  violet: 'var(--color-violet-500-solid)',
  magenta: 'var(--color-magenta-500-solid)',
  teal: 'var(--color-teal-500-solid)',
  amber: 'var(--color-amber-500-solid)',
  red: 'var(--color-red-500-solid)',
}

export type TagProps = {
  className?: string
  color?: TagColor
  label?: string
  onClick?: () => void
  onClose?: () => void
  children: ReactNode
}

export const Tag = (props: TagProps) => {
  const { className, color = 'violet', label, onClick, onClose, children } = props

  const handleClose = (event: React.MouseEvent) => {
    event.stopPropagation()
    onClose?.()
  }

  return (
    <span
      className={cx('tag', { 'tag--clickable': !!onClick }, className)}
      style={{ '--tag-color': tagColorMap[color] } as React.CSSProperties}
      onClick={onClick}
    >
      {label && <span className="tag__label">{label}</span>}
      {children}
      {onClose && (
        <span className="tag__close" onClick={handleClose}>
          <Icon className="tag__close-icon" name="x" />
        </span>
      )}
    </span>
  )
}
